import React, { useEffect, useState, useRef } from 'react';
import bgImage from '../../pages/culture/cultureImage/banner-bg.209b7822a63dca486753.svg'
import Software from '../culture/cultureImage/7-years.jpg'
import Celebrating from './celebrating';
import AOS from 'aos';
import 'aos/dist/aos.css';
import AboutImage from '../../../assests/images/journeyt.png';

const Journey = () => {
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    const [bgPositionY, setBgPositionY] = useState(5.69531);
    const [bgPositionYx, setBgPositionYx] = useState(2.45);

    useEffect(() => {
        AOS.init({
            duration: 1000, // animation duration
            once: true, // whether animation should happen only once
        });
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                const { isIntersecting, boundingClientRect } = entry;
                const isEnteringFromBottom = isIntersecting && boundingClientRect.top > 0;

                setIsVisible(isEnteringFromBottom);
            },
            { threshold: 0.1 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);
    const data = {
        title: "🥳 Celebrating Rang Panchami: A Day of Colors and Camaraderie 🥳",
        image: {
            src: Software,
        },
        paragraphs: [
            "This Rang Panchami, our office was 🌈✨ filled with vibrant colors and joy as we celebrated the festival together.",
            "We had an amazing time playing with colors 🎨, sharing laughter 😂, and bonding with colleagues 🤝",
            "The day was full of fun, with bright splashes of color, music 🎶, and delicious treats 🍬. It was a beautiful reminder of the power of togetherness and creating happy moments at work."
        ]
    };
    // Scroll event to adjust background position
    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            const newPositionY = 5.69531 - scrollY * 0.5; // Adjust the multiplier as needed
            const newPositionYx = 2.69531 - scrollY * 0.3; // Adjust the multiplier as needed
            setBgPositionY(newPositionY);
            setBgPositionYx(newPositionYx);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className='z-10 '>
            <section
                ref={sectionRef}
                className={`relative w-full lg:h-[450px] h-full bg-fixed bg-center bg-cover bg-[#c2e9ff]`}
                // style={{
                //     backgroundImage: `url(${AboutImage})`,
                // }}
            >
                <div className="absolute inset-0"></div>
                <div className="container mx-auto h-full flex items-center justify-center text-center">
                    <div className="text-white">
                        <h1 className='text-[#09588D] font-bold text-center lg:mt-10 mt-40 font-recoleta text-[64px] 2xl:text-[40px] lg:text-[32px] ' style={{ fontWeight: '600' }} data-aos="fade-up">Life @ TekIT</h1>
                        {/* <img src={bgImage} className='py-4 justify-self-end w-[300px] pr-20' /> */}
                        <h2 className='text-[#09588D] font-bold text-center font-recoleta text-[70px] 2xl:text-[40px] lg:text-[32px] ' style={{ fontWeight: '700' }} data-aos="fade-up">TekIT is all about the VIBES!</h2>
                        <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] px-14 text-center mt-10 text-[#000]' >
                            Despite coming from different backgrounds and cities, <span className=' font-bold text-[#09588D]'>TekIT Software Solutions</span>  is one joyful family with a variety of personalities.
                        </p>
                        <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] px-14 text-center mt-14 text-[#000]'>
                            The keys to building a pure relationship between us are <span className=' font-bold text-[#09588D]'>innovation, passion and dedication.</span>
                        </p>
                    </div>
                </div>
            </section>
            <div className='px-6 lg:max-w-8xl w-[90%] mx-auto lg:px-14 py-16 lg:py-2 bg-white font-recoleta'>

                <div>
                    <h1 className='text-[#F86F4B] 2xl:text-[32px] lg:text-[24px] text-[54px] font-bold px-14 text-center mt-12' data-aos="fade-up">🚀 TekIT Software Solutions Turns 7! 🎉</h1>
                    <div className='lg:flex mt-12'>
                        <div className='lg:w-[45%] w-full'>
                            <div className="relative w-full  bg-white overflow-hidden">
                                {/* Rotating Circle with Circular Motion */}
                                {/* <div className="absolute w-72 h-72 border-2 border-gray-200 rounded-full animate-circular-motion top-30 left-20"></div> */}
                                {/* <div className="absolute w-72 h-72 border-2 border-gray-200 rounded-full animate-circular-motion top-25 left-10"></div> */}
                                {/* Image */}
                                <img
                                    src={Software}
                                    data-aos="fade-right"
                                    alt=" Celebration"
                                    className="relative z-1 w-full h-full object-cover p-2 rounded-lg"
                                />
                            </div>

                            {/* <img src={Software} className='p-4 w-full' />  */}
                        </div>
                        <div className='lg:w-[55%] w-full content-center p-4 font-recoleta' >

                            <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-4'>On 13th February 2025, we celebrated 7 incredible years of building, growing, and thriving together!</p>
                            <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-2'>From humble beginnings to a powerhouse of innovation — it’s been a journey worth celebrating! </p>
                            <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-3 font-semibold'>🎉 Highlights of the day: </p>
                            <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-2 ml-7'>🔹 New Logo Reveal </p>
                            <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 ml-7'>🔹 Website Relaunch </p>
                            <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 ml-7'>🔹 Cake Cutting & Office Party </p>
                            <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 ml-7'>🔹 Laughter, Memories & Teammate Vibes </p>
                            <p data-aos="fade-left" className='2xl:text-[22px]  lg:text-[14px] text-[34px] space-y-10 mt-3'>A big shoutout to our dedicated team, partners, and clients who made this journey possible. Cheers to many more milestones ahead! 🥂</p>
                        </div>
                    </div>
                </div>
                <Celebrating />
            </div>
        </div>

    );
};

export default Journey;
